/**
 * Frontend Configuration
 * Centralized configuration for API URLs and other settings
 */

const config = {
  // Base URLs for different environments
  baseUrls: {
    production: process.env.REACT_APP_BACKEND_URL || "https://visitingcard.demopsts.com",
    development: process.env.REACT_APP_API_BASE_URL?.replace('/api', '') || "http://localhost:8000",
  },

  // Get API base URL from environment variable or use default based on environment
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 
    (process.env.NODE_ENV === "production" 
      ? "https://visitingcard.demopsts.com/api"
      : "http://localhost:8000/api"),
  
  // Get static base URL from environment variable or use default based on environment
  staticBaseUrl: process.env.REACT_APP_STATIC_BASE_URL || 
    (process.env.NODE_ENV === "production"
      ? "https://visitingcard.demopsts.com/static"
      : "http://localhost:8000/static"),

  // Frontend/Public URLs (for QR codes and sharing)
  frontendUrl: process.env.REACT_APP_FRONTEND_URL || 
    (process.env.NODE_ENV === "production"
      ? "https://visitingcard.demopsts.com"
      : "http://localhost:3000"),
  
  publicBaseUrl: process.env.REACT_APP_PUBLIC_BASE_URL || 
    (process.env.NODE_ENV === "production"
      ? "https://visitingcard.demopsts.com"
      : process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000"),

  // Environment settings
  environment: process.env.NODE_ENV || "development",
  debug: process.env.REACT_APP_DEBUG === "true",

  // Helper function to get the current base URL
  getBaseUrl: () => {
    if (process.env.REACT_APP_API_BASE_URL) {
      return process.env.REACT_APP_API_BASE_URL.replace('/api', '');
    }
    return process.env.NODE_ENV === "production"
      ? config.baseUrls.production
      : config.baseUrls.development;
  },

  // Helper function to get API URL
  getApiUrl: () => {
    return process.env.REACT_APP_API_BASE_URL || `${config.getBaseUrl()}/api`;
  },

  // Helper function to get static URL
  getStaticUrl: () => {
    return process.env.REACT_APP_STATIC_BASE_URL || `${config.getBaseUrl()}/static`;
  },

  // Helper function to get frontend URL
  getFrontendUrl: () => {
    return process.env.REACT_APP_FRONTEND_URL || config.frontendUrl;
  }
};

export default config;

// You can also export individual pieces for easier imports
export const { 
  apiBaseUrl, 
  staticBaseUrl, 
  frontendUrl,
  publicBaseUrl,
  environment, 
  debug,
  getBaseUrl,
  getApiUrl, 
  getStaticUrl,
  getFrontendUrl
} = config; 